import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import { TerraUtils } from '../TerraUtils';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'utcDate',
  standalone: true
})
export class UtcDatePipe implements PipeTransform {
  constructor(private datePipe: DatePipe) {
    
  }

  transform(value: Date | null | undefined, format?: string, timezone?: string, locale?: string): string | null {
    return !!value ? this.datePipe.transform(TerraUtils.forceUtcToLocal(value)) : null;
  }
}